import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import NavBar from '../components/Navbar/NavBar';
import websiteIcon from '../images/web_site.png';
import appleStoreIcon from '../images/apple_store.png';
import googlePlayIcon from '../images/play_store.png';
import products from '../components/products'; 

const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    const selectedProduct = products.find((item) => String(item.id) === String(id));
    setProduct(selectedProduct);
  }, [id]);

  if (!product) {
    return <div>Loading...</div>;
  }

  return (
    <div className="product-detail-container">
      <NavBar />
      <div className="p-8 mt-16">
        <div className="flex flex-col items-center md:flex-row">
          <img
            src={product.image}
            alt={product.name}
            className="max-w-sm rounded-lg shadow-lg"
          />
          <div className="ml-8 text-center md:text-left">
            <h1 className="text-4xl font-extrabold text-white">{product.name}</h1>
            <p className="text-xl text-white mt-4">{product.description}</p>
          </div>
        </div>
        <div className="mt-12">
  <h2 className="text-3xl font-bold text-white text-center">Product Photos</h2>
  <div className={`grid gap-6 mt-6 ${product.id === '2' ? 'grid-cols-3' : 'grid-cols-4'}`}>
    {product.photos.map((photo, index) => (
      <img
        key={index}
        src={photo}
        alt={`Product ${index}`}
        className={`${
          product.id === '2' ? 'w-full' : 'w-48 h-100'
        } h-auto rounded-lg shadow-lg`} 
      />
    ))}
  </div>
</div>

        <div className="flex justify-center mt-8 space-x-6">
          <a
            href={product.websiteLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center"
          >
            <img src={websiteIcon} alt="Website" className="w-16 h-16" />
          </a>
          <a
            href={product.appleStoreLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center"
          >
            <img src={appleStoreIcon} alt="Apple Store" className="w-64 h-16" />
          </a>
          <a
            href={product.googlePlayLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center"
          >
            <img src={googlePlayIcon} alt="Google Play" className="w-64 h-16" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
